import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type RouteIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

/** Two waypoints joined by a path — guard tours. */
export const RouteIcon = ({
  size = 16,
  color,
  colorScheme = 'dark',
  className,
}: RouteIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  // Decorative: unlike most icons here (aria-label + role='img'), this one
  // is aria-hidden. It always sits beside text that carries the meaning (a
  // StatTile label, a feed row title), so a label would only repeat or
  // contradict it, and a hardcoded English one wouldn't be translated.
  return (
    <svg
      aria-hidden='true'
      className={className}
      fill='none'
      height={size}
      viewBox='0 0 16 16'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.33333 4C5.33333 3.26362 4.73638 2.66667 4 2.66667C3.26362 2.66667 2.66667 3.26362 2.66667 4C2.66667 4.73638 3.26362 5.33333 4 5.33333C4.73638 5.33333 5.33333 4.73638 5.33333 4ZM13.3333 12C13.3333 11.2636 12.7364 10.6667 12 10.6667C11.2636 10.6667 10.6667 11.2636 10.6667 12C10.6667 12.7364 11.2636 13.3333 12 13.3333C12.7364 13.3333 13.3333 12.7364 13.3333 12ZM14.6667 12C14.6667 13.4728 13.4728 14.6667 12 14.6667C10.5272 14.6667 9.33333 13.4728 9.33333 12C9.33333 10.7574 10.1832 9.71334 11.3333 9.41732V5.33333C11.3333 5.15652 11.263 4.987 11.138 4.86198C11.0286 4.75255 10.8851 4.68505 10.7324 4.66992L10.6667 4.66667H8.66667C8.29848 4.66667 8 4.36819 8 4C8 3.63181 8.29848 3.33333 8.66667 3.33333H10.6667C11.1971 3.33333 11.7057 3.5442 12.0807 3.91927C12.4558 4.29434 12.6667 4.8029 12.6667 5.33333V9.41732C13.8168 9.71334 14.6667 10.7574 14.6667 12ZM6.66667 4C6.66667 5.24256 5.81682 6.28666 4.66667 6.58268V14C4.66667 14.3682 4.36819 14.6667 4 14.6667C3.63181 14.6667 3.33333 14.3682 3.33333 14V6.58268C2.18318 6.28666 1.33333 5.24256 1.33333 4C1.33333 2.52724 2.52724 1.33333 4 1.33333C5.47276 1.33333 6.66667 2.52724 6.66667 4Z'
        fill={resolvedColor}
      />
    </svg>
  )
}
